export default {
  install (app) {
    const { $exception } = app.config.globalProperties

    app.config.globalProperties.__t = (post = 0) => {
      if (post === 0) return $exception('SiteLanguage plugin: No post specified.')
      const texts = JSON.parse(localStorage.getItem('site_texts'))
      const item = texts.find(o => o.post === post)

      if (!item) {
        const textsEnglish = JSON.parse(localStorage.getItem('site_texts_gb'))
        if (textsEnglish) {
          const itemEnglish = textsEnglish.find(o => o.post === post)
          if (itemEnglish) return itemEnglish.text
        }
        const language = localStorage.getItem('site_language') ?? 'unknown'
        $exception(`SiteLanguage plugin: Could not find text for post ${post}, in language ${language}.`)
        return (typeof window.ecoonline === 'undefined' || window.ecoonline.env === 'p') ? '' : `js:ecoonline::text.${post}`
      }

      return item.text
    }
  }
}
